import { useSettings } from '@/hooks/useProducts';
import { SITE_TYPE } from '@/config/site';
import { resolveLook } from '@rumio/site-templates';
import type { ResolvedLook } from '@rumio/site-templates';

/**
 * The tenant's Look, resolved from `site_settings.theme_config.look` with the
 * site type's default as the fallback. One hook instead of four hand-rolled
 * `resolveLook(settingsData?.settings?.theme_config?.look, SITE_TYPE)` calls,
 * so every consumer (layout chrome, hero, homepage, product card CSS knob)
 * agrees on the same resolution — and inside a Design Sandbox preview frame
 * they all see the candidate Look, because `useSettings` substitutes it.
 */
export function useResolvedLook(): ResolvedLook {
  const { data } = useSettings();
  return resolveLook(data?.settings?.theme_config?.look, SITE_TYPE);
}
